const GraphqlData = window.GraphqlData;

export const LineUp = {
  props: [
    "makeByDefault",
    "selectedCategory",
    "makes",
    "makesLogos",
    "colorizerOrientation",
    "excludedModelsOption",
    "lang",
    "graphqlEndpoint",
    "excludedCategories",
    "modelOrder",
    "categoryOrder"
  ],
  data() {
    return {
      vehicles: [],
      categories: [],
      categorySelected: this.selectedCategory || "All",
      selectedMake: this.makeByDefault || null,
      makesSelector: [],
      hasData: true,
      firstLoad: false,
    };
  },
  created() {
  },
  mounted() {
    if (this.makes) {
      const imagesUrl = "https://v5websitescdn.blob.core.windows.net/v5cdn/components/makes/";
      // Convert string to array
      this.makesSelector = this.makes.split(",");
      // Add image url to each make
      this.makesSelector = this.makesSelector.map((make) => {
        const logo = (this.makesLogos || {})[make.trim().toLowerCase()] || {};
        return {
          make: make.toLowerCase(),
          imageUrl: logo.url || `${imagesUrl}${make.toLowerCase()}.png`,
          width: logo.width || null,
          height: logo.height || null,
        };
      });
    }

    if (this.selectedMake) {
      let showA = this.selectedCategory.toLowerCase() == "all" ? true : false;
      this.whenNearViewport(() => this.getData(this.selectedMake, showA));
    }
  },
  methods: {
    whenNearViewport(callback) {
      if (!("IntersectionObserver" in window)) return callback();
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          callback();
        }
      }, { rootMargin: "400px 0px" });
      observer.observe(this.$el);
    },
    selectCategory(category) {
      this.categorySelected = category;

      jQuery(".line-up-6__models-section").css({
        visibility: "invisible",
        opacity: 0,
      });
      setTimeout(() => {
        jQuery(".line-up-6__models-section").slick("slickUnfilter");

        if (category != "All")
          jQuery(".line-up-6__models-section").slick(
            "slickFilter",
            `.${category.replace(/ /g, "").replace(/&/g, "").toLowerCase()}`
          );

        jQuery(".line-up-6__models-section").slick("refresh");
        jQuery(".line-up-6__models-section").css({
          visibility: "visible",
          opacity: 1,
          "transition-delay": "0s",
        });
      }, 400);
    },
    selectMake(make) {
      if (make == this.selectedMake || !make) return;

      this.categorySelected = "All";
      this.vehicles = null;
      this.selectedMake = make;
      this.getData(make, true);
    },
    getData(make, showAll, loadOtherMakes = false) {
      // Generar una clave única para sessionStorage basada en 'make'
      const storageKey = `vehicles_v2_${make}`;

      // Verificar si los datos ya están en sessionStorage
      const cachedData = sessionStorage.getItem(storageKey);

      if (cachedData && !loadOtherMakes) {
        // Parsear y usar los datos almacenados en sessionStorage
        this.vehicles = null;
        setTimeout(() => {
          this.vehicles = JSON.parse(cachedData);
          this.processVehicles(showAll);
        }, 200);
      } else if (!cachedData) {
        // Si los datos no están en sessionStorage, hacer la consulta a GraphQL
        GraphqlData.authenticateAndFetchData(
          make,
          "lineup",
          null,
          null,
          this.graphqlEndpoint
        )
          .then((result) => {
            // Almacenar los datos en sessionStorage
            sessionStorage.setItem(storageKey, JSON.stringify(result));

            if (!loadOtherMakes) {
              this.vehicles = result;
              this.processVehicles(showAll);
            }
          })
          .catch((error) => {
            console.error("Error:", error.message);
          });
      }
    },
    processVehicles(showAll) {
      // Filtrar los vehículos excluidos
      if (this.excludedModelsOption) {
        this.vehicles = this.vehicles.filter((vehicle) => {
          const vehicleModel = `${
            vehicle.modelData.year
          } ${vehicle.modelData.model.toLowerCase()}`;
          const excludedModels = this.excludedModelsOption.map((model) =>
            model.toLowerCase()
          );
          return !excludedModels.includes(vehicleModel);
        });
      }

      // Agregar nueva propiedad a los vehículos para la imagen por defecto
      this.vehicles.forEach((vehicle) => {
        let mainImage = null;

        if (
          this.colorizerOrientation &&
          vehicle?.modelData?.colorizer?.length > 0
        ) {
          for (let col of vehicle.modelData.colorizer) {
            if (col.images && col.images.length > 0) {
              for (let img of col.images) {
                if (img.imageType === this.colorizerOrientation) {
                  mainImage = img.image || img.url;
                  break;
                }
              }
              if (mainImage) break;
            }
          }
        }

        if (!mainImage) {
          mainImage =
            (vehicle.modelData.jellybean?.sourceUrl && vehicle.modelData.jellybean) ||
            vehicle.modelData.colorizer[0]?.images[0]?.image ||
            vehicle.modelData.colorizer[0]?.images[0]?.url;
        }

        let mainImageSrcset = null;

        // Asegurarse de que mainImage sea siempre un string URL
        if (typeof mainImage === "object" && mainImage.sourceUrl) {
          mainImageSrcset = mainImage.srcSet || null;
          mainImage = mainImage.sourceUrl;
        }

        vehicle.modelData.mainImage = mainImage;
        vehicle.modelData.mainImageSrcset = mainImageSrcset;
        vehicle.modelData.slug = `${this.lang == "en-CA" ? "/new" : "/neufs"}/${
          vehicle.modelData.year
        }-${vehicle.modelData.make
          .toLowerCase()
          .replace(/ /g, "-")}-${vehicle.modelData.model
          .toLowerCase()
          .replace(/ /g, "-")}/`;
      });

      this.vehicles = this.vehicles.map((vehicle) => ({
        ...vehicle,
        loading: true,
        error: false,
      }));

      this.hasData = this.vehicles.length > 0;

      // Paso 1: Extraer categorías de los vehículos
      let categories = {};
      this.vehicles.forEach((item) => {
        if (!categories[item.modelData.category]) {
          categories[item.modelData.category] = 1;
        }
      });
      // remove duplicates from object
      categories = Object.keys(categories);

      const allCategories = categories.reduce((result, category) => {
        return result.concat(category.split(",").map((c) => c.trim()));
      }, []);

      // Paso 2: Eliminar duplicados
      const uniqueCategories = [...new Set(allCategories)];

      // Add "All" category first
      if (uniqueCategories.length > 1) {
        uniqueCategories.unshift("All");
      }

       /* Ordenando por categorias especificos */
      if(this.categoryOrder && this.categoryOrder.length > 0) {
        const orderLC = this.categoryOrder.map(m => m.toLowerCase());

        const rank = new Map(orderLC.map((m, i) => [m, i]));

        uniqueCategories.sort((a, b) => {
          const categoryA = a.toLowerCase();
          const categoryB = b.toLowerCase();

          const aIn = rank.has(categoryA);
          const bIn = rank.has(categoryB);

          if (aIn && !bIn) return -1;
          if (!aIn && bIn) return 1;

          if (aIn && bIn) return rank.get(categoryA) - rank.get(categoryB);

          return categoryA.localeCompare(categoryB);
        });
      }

      this.categories = uniqueCategories;

      setTimeout(() => {
        const slickOptions = {
          dots: false,
          arrows: true,
          prevArrow:
            '<button class="lbx-arrow lbx-arrow-prev slick-arrow" aria-label="Previous" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6"/></svg></button>',
          nextArrow:
            '<button class="lbx-arrow lbx-arrow-next slick-arrow" aria-label="Next" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6"/></svg></button>',
          infinite: false,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 0,
          responsive: [
            {
              breakpoint: 1536,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        };

        const slickElement = jQuery(".line-up-6__models-section");

        if (!slickElement.hasClass("slick-initialized")) {
          slickElement.slick(slickOptions);
        } else {
          slickElement.slick("refresh");
        }

        slickElement.slick("slickUnfilter");

        if (!showAll) {
          slickElement.slick(
            "slickFilter",
            `.${this.categorySelected
              .replace(/ /g, "")
              .replace(/&/g, "")
              .toLowerCase()}`
          );
        }

        // Muestra el contenedor una vez que Slick se ha inicializado
        slickElement.css({
          visibility: "visible",
          opacity: 1,
          "transition-delay": "0s",
        });
        this.firstLoad = true;
      }, 50);

      /* Ordenando por modelos especificos */
      if(this.modelOrder && this.modelOrder.length > 0) {
        const orderLC = this.modelOrder.map(m => m.toLowerCase());

        const rank = new Map(orderLC.map((m, i) => [m, i]));

        this.vehicles.sort((a, b) => {
          const modelA = a.modelData.model.toLowerCase();
          const modelB = b.modelData.model.toLowerCase();

          const aIn = rank.has(modelA);
          const bIn = rank.has(modelB);

          if (aIn && !bIn) return -1;
          if (!aIn && bIn) return 1;

          if (aIn && bIn) return rank.get(modelA) - rank.get(modelB);

          return modelA.localeCompare(modelB);
        });
      }
    },
    getClassList(categories) {
      let classes = "line-up-6__models-section__model text-center";
      categories.forEach((category) => {
        classes += ` ${category
          .replace(/ /g, "")
          .replace(/&/g, "")
          .toLowerCase()}`;
      });
      return classes;
    },
    isMoreThanZero(array) {
      return array.length > 0;
    },
    isMoreThanOne(array) {
      return array.length > 1;
    },
    logoStyle(makes) {
      return makes.width && makes.height ? { width: `${(40 * makes.width) / makes.height}px` } : null;
    },
    onLoad(index) {
      this.vehicles[index].loading = false;
    },
    onError(index) {
      this.vehicles[index].loading = false;
      this.vehicles[index].error = true;
    },
    loadingTemplate() {
      return `
        <div role="status" class="flex justify-center items-center">
          <svg aria-hidden="true" class="mr-2 w-8 h-8 text-gray-200 animate-spin"
            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor" />
            <path class="fill-current text-primary"
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="none" />
          </svg>
        </div>
        <span class="flex justify-center items-center font-primary-bold loading-text">${
          this.lang == "en-CA" ? "Loading" : "Chargement"
        }...</span>`;
    },
  },
  watch: {
    firstLoad(newVal) {
      if (newVal && this.makes) {
        let makes = this.makes.split(",");
        makes.forEach((make) => {
          if (make.toLowerCase() != this.selectedMake) {
            this.getData(make.toLowerCase(), false, true);
          }
        });
      }
    },
  },
  filters: {
    moneyFormat: (price, lang, digits = 0) => {
      var formatter = new Intl.NumberFormat(lang, {
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: digits,
      });
      return digits != 0
        ? formatter.format(price)
        : formatter.format(Math.floor(price));
    },
  },
};